import React from 'react';
import { LabelInput, LabelSelect, PercentageInput } from '../../../components/Input/Input';
import { COST_CENTER_TYPE_OPTIONS, STATUS_OPTIONS } from '../../../core/constants/financial';
import FinancialFormModal from './FinancialFormModal';

const CostCenterFormModal = ({ form, setForm, editingId, onSave, onClose, onDelete, saving }) => {
  const onChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <FinancialFormModal
      title={editingId ? 'Editar Centro de Custo' : 'Novo Centro de Custo'}
      onClose={onClose}
      onSave={onSave}
      onDelete={onDelete}
      saving={saving}
    >
      <div className="fd-form-row fd-form-row--code-name">
        <LabelInput
          label="Código"
          value={form.code}
          placeholder="CC-01"
          max={20}
          onChange={(value) => onChange('code', value)}
        />
        <LabelInput
          label="Nome"
          value={form.name}
          placeholder="Ex: Funilaria e Pintura"
          max={150}
          onChange={(value) => onChange('name', value)}
        />
      </div>

      <div className="fd-form-row">
        <LabelSelect menuPortalTarget={document.body}
          label="Tipo"
          options={COST_CENTER_TYPE_OPTIONS}
          value={COST_CENTER_TYPE_OPTIONS.find((o) => o.value === form.type)}
          placeholder="Selecione"
          onChange={(opt) => onChange('type', opt?.value || 'produtivo')}
        />
        <LabelInput
          label="Responsável"
          value={form.responsible}
          placeholder="Nome do responsável"
          max={150}
          onChange={(value) => onChange('responsible', value)}
        />
      </div>

      <div className="fd-form-row">
        <PercentageInput
          label="% de Rateio"
          value={form.percentage}
          placeholder="0"
          onChange={(value) => onChange('percentage', value)}
        />
        <LabelSelect menuPortalTarget={document.body}
          label="Status"
          options={STATUS_OPTIONS}
          value={STATUS_OPTIONS.find((o) => o.value === form.status)}
          placeholder="Selecione"
          onChange={(opt) => onChange('status', opt?.value || 'ativo')}
        />
      </div>

      <LabelInput
        label="Descrição"
        value={form.description}
        placeholder="Descrição opcional do centro de custo..."
        max={255}
        onChange={(value) => onChange('description', value)}
      />
    </FinancialFormModal>
  );
};

export default CostCenterFormModal;
